<template lang="pug">
div
  .main
    app-modal-redefinirSenha.modalSenha(v-if="modalIsOpen" @closeModal="closeModalRedefinirSenha")
    el-card.box-card
      validation-observer(ref='observer' tag='form')
        form(@keyup.enter="logar()")
          img.logo(v-if="isAmbienteTeste" src="../../../assets/images/logo.png", @click="activeFake()")
          img.logo(v-else src="../../../assets/images/logo.png")

          .item
            validation-provider(rules="required|cpf_cnpj", v-slot="{ errors }" mode="lazy")
              el-input.input(
                :class="{'erro' : errors.length}",
                placeholder="CPF/CNPJ",
                id="input_cpf"
                v-model="login"
                v-mask="['###.###.###-##', '##.###.###/####-##']",
                masked="true",
              )
              span.help.erro {{ errors[0] }}

          .item
            validation-provider(rules="required", v-slot="{ errors }" mode="lazy" )
              el-input.input(
                :class="{'erro' : errors.length}",
                placeholder="Senha",
                v-model="senha"
                id="input_senha"
                type="password",
              )
              span.help.erro {{ errors[0] }}

          .item
            el-button.full-width(
              @click="logar()",
              :disabled="loading",
              type="success"
            )
              span(v-if="!loading") Entrar
              i(v-else).el-icon-loading

        .buttons
          el-button(
            @click="openModalRedefinirSenha()",
            type="text"
          )
            span Redefinir senha
          el-button(
            @click="criarConta()",
            type="text"
          )
            span Criar conta

    .login-gov-br(v-if="loginBovBr")
      el-divider(content-position="center")
        span ou
      .item
        el-button.full-width.button-gov-br(
          @click="logarGov",
          :disabled="loading",
          type="success"
        )
          span Entrar com
          span.gov-br &nbsp;gov.br

  .list-user(v-if="listaUsuarios && listaUsuarios.length > 0")
    el-table(
      :data="listaUsuarios"
    )
      template(slot="empty") Não há registros.
      el-table-column(
        prop='pessoa.nomeRazaoSocial',
        label='Nome/Razão Social',
        width="auto"
      )
      el-table-column(
        prop='pessoa.cpfCnpj',
        label='CPF/CNPJ',
        width="auto"
      )
      el-table-column(
        prop="perfis",
        align="left",
        label="Perfis"
      )
        template(slot-scope="scope")
          .lista
            ul(v-for="perfil in scope.row.perfis")
              li {{perfil.nome}}
      el-table-column(
        label='Ações',
        width='120',
        align='center'
      )
        template(slot-scope='scope')
          el-button(type='primary', size="small" @click="fakeLogin(scope.row)") Login

</template>

<script>
import { mapActions } from 'vuex'
import AppModalRedefinirSenha from '@/screens/portal/seguranca/components/AppModalRedefinirSenha.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  name: 'Login',

  components: {
    AppModalRedefinirSenha
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      login: '',
      senha: '',
      loading: false,
      loginError: false,
      senhaError: false,
      modalIsOpen: false,
      loginBovBr: false,
      listaUsuarios: [],
      isAmbienteTeste: (process.env.NODE_ENV === 'development' || process.env.NODE_ENV.split('_')[0] === 'testing'),
      click: 0
    }
  },

  async mounted () {
    this.activeListLogin(this.$store.state.loginFake.isLoginFakeActive)
    this.getConfiguracao()
      .then((result) => {
        this.loginBovBr = result.loginBovBr
      })
  },

  methods: {
    ...mapActions({
      loginPortalSeguranca: 'auth/loginPortalSeguranca',
      findUsuarios: 'usuario/findAll',
      setLoginFake: 'loginFake/setLoginFake',
      getConfiguracao: 'dados/getConfiguracao'
    }),

    async logarGov () {
      window.location.href = `${process.env.ROOT_URL}autenticacao/sso/login?tipo=GOV_BR`
    },

    async fakeLogin (row) {
      await this.loginPortalSeguranca({ login: row.pessoa.cpfCnpj, senha: btoa('123456') })

      this.$router.push({ name: 'selecionarModulo' })
    },

    async logar () {
      if (await this.$refs.observer.validate()) {
        await this.loginPortalSeguranca({ login: this.login, senha: btoa(this.senha) })

        this.$router.push({ name: 'selecionarModulo' })
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    },

    openModalRedefinirSenha () {
      this.modalIsOpen = true
    },

    closeModalRedefinirSenha () {
      this.modalIsOpen = false
    },

    criarConta () {
      this.$router.push({
        name: 'cadastroUsuario',
        params: {
          tipo: 'externo'
        }
      })
    },

    async activeFake () {
      this.click++
      const loginFake = await this.setLoginFake(this.isAmbienteTeste && this.click > 1)
      this.activeListLogin(loginFake)
    },

    async activeListLogin (loginFake) {
      if (loginFake) {
        this.listaUsuarios = await this.findUsuarios()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.main {
  display: flex;
  justify-content: center;
  padding: 9%;
  align-items: center;
}

@media screen and (min-width: 901px) {
  .main {
    flex-direction: column;
  }
}

@media screen and (max-width: 900px) {
  .main {
    flex-wrap: wrap;
  }
}

.box-card {
  width: 600px;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: block;
}

.login-gov-br {
  width: 600px;

  .el-divider__text {
    color: $font-color;
  }
}

.list-user {
  display: flex;
  align-self: center;
  padding: 0 10%;
  .lista {
    ul,
    li {
      margin: 0;
      padding: 0;
      list-style: none;
    }
  }
}

.logo {
  width: 100%;
  height: 50%;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.item {
  padding: 10px 0px;
}

.button-gov-br {
  background-color: #1351B4;
  color: #fff;
  border: #1351B4;
  border-radius: 30px;
  .gov-br {
    font-weight: bold;
  }
}

.button-gov-br:hover {
  opacity: 0.8;
}

@media (max-width: 780px) {
  .modalSenha {
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/Login.vue